import {
  Stage, Layer, Text,
} from 'react-konva';

import { Cached } from '@mui/icons-material';
import classes from './Captcha.module.css';

interface Props {
  code: string
  generate: () => void
}

const STAGE_HEIGHT = 80;
const STAGE_WIDTH = 200;
const RANDOM_FACTOR_Y = 10;
const RANDOM_FACTOR_X = 5;
const RANDOM_FACTOR_ROTATION = 20;
const FONT_SIZE = 22;

export default function Captcha({ code, generate }: Props) {
  const renderChars = () => [...code].map((char, i) => {
    // Generate random Y number
    // Set it to be positive for even numbers
    let randomY = Math.floor(Math.random() * RANDOM_FACTOR_Y * 2) - RANDOM_FACTOR_Y;
    if (i % 2 === 0) randomY = Math.abs(randomY);
    const y = (STAGE_HEIGHT / 2) - (FONT_SIZE / 1.3) + randomY;

    // Generate random X number
    const x = i * (FONT_SIZE * 1.1) + (STAGE_WIDTH / 2 - (FONT_SIZE * 2.75)) + RANDOM_FACTOR_X;

    // Generate random roation number
    const randomRotation = Math.floor(Math.random() * RANDOM_FACTOR_ROTATION * 2) - RANDOM_FACTOR_ROTATION;

    return (
      <Text
        // eslint-disable-next-line react/no-array-index-key
        key={i}
        y={y}
        x={x}
        fontSize={FONT_SIZE}
        height={FONT_SIZE}
        fontFamily="cursive"
        text={char}
        fill="white"
        rotation={randomRotation}
      />
    );
  });

  return (
    <div className={classes.container}>
      <div className={classes.row}>
        <div className={classes.captcha}>
          <Stage width={STAGE_WIDTH} height={STAGE_HEIGHT}>
            <Layer>
              {renderChars()}
            </Layer>
          </Stage>
        </div>

        <button type="button" className={`btn btn-light ${classes.button}`} onClick={generate}>
          <Cached fontSize="small" />
        </button>
      </div>

      <div className="d-flex align-items-center mt-2">
        <input type="text" className="form-control" required maxLength={5} />
      </div>
    </div>
  );
}
